define([
	"./TextToolbarSelect",
	"csi/html",
	"designSystem/fonts",
	"./_Plugin",
	"./PluginFactory"
], function(TextToolbarSelect, html, fonts, _Plugin, PluginFactory) {

	return PluginFactory.declare([TextToolbarSelect, _Plugin], {
		"class": "svgSelect csi-text-formatting-select-button",
		cssStyle: "font-family",
		fontFamily: "Arial",
		pluginName: "fontFamily",
		title: "CanvasFontFamily",

		/**
		 * populate font-size store with values based on SVG height
		 */
		postMixInProperties: function() {
			const fontFamilies = fonts.getFontFamilyNames();
			this.options = fontFamilies.map((s) => {
				// add style to dropdown menu
				const span = html.create("span", {
					style: { fontFamily: s },
					innerText: s
				});

				return {label: span.outerHTML, value: s};
			});
			this.inherited(arguments);
		},

		/**
		 * update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const {
				cssStyle,
				fontFamily,
				editor,
			} = this;

			let value;
			if (shapes && shapes.length && editor.isSelectCanvasMode()) {
				value = editor.canvasApp.selection.getCommonTextValue(shapes, cssStyle, true);
			} else {
				value = textAttrs[cssStyle] || fontFamily;
			}

			this.set("value", value, false);
			return true;
		},


		/**
		 * Apply style
		 * @param  {Object} value
		 */
		onChange: function(value) {
			this.editor.setTextStyle(this.cssStyle, value, true);
		}
	});
});
